import { Pipe, PipeTransform } from '@angular/core';
import { UsuarioFuncionalidade } from '../../modelos/usuario-funcionalidade';

@Pipe({
  name: 'filtroUsuariosFuncionalidade',
  pure: false
})
export class FiltroUsuariosFuncionalidadePipe implements PipeTransform {

  transform(usuariosFuncionalidade: UsuarioFuncionalidade[], filtro?: string): any {
    if (usuariosFuncionalidade === undefined || filtro === undefined || filtro.trim() === '') {
      return usuariosFuncionalidade;
    }
    filtro = filtro.toLocaleLowerCase();
    return usuariosFuncionalidade.filter(usuarioFuncionalidade =>
      usuarioFuncionalidade.usuario.nomeUsuario.toLocaleLowerCase().indexOf(filtro) >= 0);
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/filtros/pipes/filtro-usuarios-funcionalidade.pipe.ts